import { render } from "./savedOrders.vue?vue&type=template&id=1122b72c&scoped=true"
import script from "./savedOrders.vue?vue&type=script&lang=js"
export * from "./savedOrders.vue?vue&type=script&lang=js"

import "./savedOrders.vue?vue&type=style&index=0&id=1122b72c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1122b72c"]])

export default __exports__